"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _context = require("./context");
var _classnames = _interopRequireDefault(require("classnames"));
var _getObjectSubset = _interopRequireDefault(require("../utils/getObjectSubset"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Form = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Form, _React$PureComponent);
  var _super = _createSuper(Form);
  function Form() {
    var _this;
    _classCallCheck(this, Form);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "inputs", []);
    _defineProperty(_assertThisInitialized(_this), "removeFromForm", function (input) {
      var index = _this.inputs.indexOf(input);
      if (index > -1) {
        _this.inputs.splice(index, 1);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (ev) {
      ev.preventDefault();
      var invalid = _this.inputs.filter(function (input) {
        return !input.isValid();
      });
      if (invalid.length) {
        var _this$props$onSubmitE, _this$props;
        _this.inputs.forEach(function (input) {
          input.onBlur();
        });
        (_this$props$onSubmitE = (_this$props = _this.props).onSubmitError) === null || _this$props$onSubmitE === void 0 ? void 0 : _this$props$onSubmitE.call(_this$props, invalid);
        return;
      }
      _this.inputs.forEach(function (input) {
        return input.reset();
      });
      _this.props.onSubmit(ev);
    });
    _defineProperty(_assertThisInitialized(_this), "attachToForm", function (input) {
      if (_this.inputs.indexOf(input) === -1) {
        _this.inputs.push(input);
      }
    });
    return _this;
  }
  _createClass(Form, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.inputs = [];
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return !this.inputs.find(function (input) {
        return !input.isValid();
      });
    }
  }, {
    key: "focusOnInvalid",
    value: function focusOnInvalid() {
      var input = this.inputs.find(function (input) {
        return !input.isValid();
      });
      if (input) input.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      var ariaAttributes = (0, _getObjectSubset.default)(this.props, 'aria');
      var formClasses = (0, _classnames.default)(_defineProperty({
        "kui-form": true,
        "sa-form": true
      }, className || '', !!className));
      return /*#__PURE__*/_react.default.createElement(_context.FormProvider, {
        value: {
          attachToForm: this.attachToForm,
          removeFromForm: this.removeFromForm
        }
      }, /*#__PURE__*/_react.default.createElement("form", _extends({}, ariaAttributes, {
        onSubmit: this.onSubmit,
        className: formClasses,
        noValidate: true,
        autoComplete: this.props.autoComplete ? 'on' : 'off'
      }), this.props.children));
    }
  }]);
  return Form;
}(_react.default.PureComponent);
exports.default = Form;
_defineProperty(Form, "defaultProps", {
  autoComplete: true
});